import {MakeStore, StoreObject} from "../../../stem-core/src/state/Store";
import {field} from "../misc/StoreField";
import {apiClient} from "../../connection/BlinkApiConnection";
import {loadVersionedObjectFromResponse} from "../misc/StoreUtils";


class MerchantSDKSettings extends StoreObject {
    @field("MerchantSettingsVersion") settingsVersion;
    @field("MerchantSDKSettings") versionParent;

    @field("Merchant") merchant;
    @field(Object) initDefaultOptions; // TODO JSON
    @field(Object) defaultPgOptions;
}

export const MerchantSDKSettingsStore = MakeStore("MerchantSDKSettings", MerchantSDKSettings, {
    dependencies: ["Merchant", "MerchantSettingsVersion"],
});

export async function apiUpdateMerchantSDKSettings(data) {
    const response = await apiClient.post("merchant/update_sdk_settings/", data);
    return loadVersionedObjectFromResponse(MerchantSDKSettingsStore, response, data.merchantSdkSettingsId);
}
